import React from 'react';
import { Box, Typography, SvgIconProps } from '@mui/material';

interface EmptyStateMessageProps {
  icon: React.ComponentType<SvgIconProps>;
  title: string;
  description: string;
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({ icon: Icon, title, description }) => (
  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
    <Box sx={{ textAlign: 'center' }}>
      <Icon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Box>
  </Box>
);

export default EmptyStateMessage;
